import { takeLatest } from 'redux-saga/effects';
import fetchWorkflowConfigWorkerSaga from './workflowWorkerSaga';
import { FETCH_WORKFLOW_CONFIG_REQUEST } from '../../redux/modules/workflowConfig/workflowConfig-actions';

function* fetchWorkflowConfigSaga() {
    yield takeLatest(FETCH_WORKFLOW_CONFIG_REQUEST, fetchWorkflowConfigWorkerSaga);
}

export default fetchWorkflowConfigSaga;
